import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";

import dummy from "./facial.webp";
import armwax2 from "../images/services/waxing/armwax1.webp";
import bikiniwax2 from "../images/services/waxing/bikiniwax2.webp";
import fullbodywax5 from "../images/services/waxing/fullbodywax5.webp";
import facewax1 from "../images/services/waxing/facewax1.webp";
import fullegwax7 from "../images/services/waxing/fulllegwax7.webp";
import bellywax2 from "../images/services/waxing/bellywax2.webp";
import underarmwax1 from "../images/services/waxing/underarmwax1.webp";

import threadingeyebrow from "../images/services/threading/threadingeyebrow.webp";
import "./waxing.css";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

const waxingServices = [
  { name: "Combo Offer", slug: "combo", desc: "Save on multiple services", image: dummy },
  { name: "Hand Wax (Full / Half)", slug: "hand", desc: "Smooth & clean hands", image: armwax2 },
  { name: "Leg Wax (Full / Half)", slug: "leg", desc: "Soft & glowing legs", image: fullegwax7 },
  { name: "Full Body Wax", slug: "fullbody", desc: "Complete hair removal", image: fullbodywax5 },
  { name: "Bikini Wax", slug: "bikini", desc: "Hygienic & professional", image: bikiniwax2 },
  { name: "Underarm Wax", slug: "underarm", desc: "Precise & gentle care", image: underarmwax1 },
  { name: "Face Wax", slug: "face", desc: "Upper lip, chin, sides", image: facewax1 },
  { name: "Belly Wax", slug: "belly", desc: "Clean & smooth belly", image: bellywax2 },
];

const Waxing = () => {
  const navigate = useNavigate();

  return (
    <div className="waxing-page-bg">
      <Header />
      <Navbar />

      {/* Hero */}
      <section className="bg-light py-4">
        <div className="container text-center">
          <h2 className="fw-bold">Waxing & Threading</h2>
          <p className="text-muted mb-0">
            Professional hair removal services at home
          </p>
        </div>
      </section>

      {/* Waxing Cards */}
      <section className="container my-4">
        <h5 className="fw-bold mb-3">Waxing Services</h5>

        <div className="row row-cols-2 row-cols-md-3 row-cols-lg-4 g-3">
          {waxingServices.map((item, idx) => (
            <div key={idx} className="col">
              <div
                className="card h-100 border-0 shadow-sm waxing-card"
                onClick={() => navigate(`/category/waxing/${item.slug}`)}
              >
                <img
                  src={item.image}
                  className="card-img-top"
                  alt={item.name}
                />

                <div className="card-body text-center">
                  <h6 className="fw-bold mb-1">{item.name}</h6>
                  <p className="text-muted small mb-0">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Threading Big Card */}
      <section className="container my-5">
        <h5 className="fw-bold mb-3">Threading</h5>

        <div
          className="threading-card shadow-sm"
          onClick={() => navigate("/category/threadingservices")}
        >
          <div className="row g-0 align-items-center">
            <div className="col-md-5">
              <img src={threadingeyebrow} alt="Threading" className="threading-img" />
            </div>
            <div className="col-md-7">
              <div className="p-4">
                <h4 className="fw-bold mb-2">Threading Services</h4>
                <p className="text-muted mb-2">
                  Eyebrow, upper lip, forehead & full face threading
                </p>
                <ul className="small text-muted mb-3">
                  <li>Perfect eyebrow shaping</li>
                  <li>Gentle on sensitive skin</li>
                  <li>Quick & hygienic process</li>
                </ul>
                <button className="btn btn-primary btn-sm px-4">
                  Explore Threading
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Waxing;
